var map = {
	"./bat.webp": "d250",
	"./blue_slime.webp": "6884",
	"./evil_spirit.webp": "a452",
	"./red_slime.webp": "688f",
	"./snake.webp": "b54a",
	"./turtle.webp": "20ef",
	"./yellow_slime.webp": "c8e3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "39ec";